import React from 'react';

import { Box, Inline, Percentage } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  BodyText,
  Stack,
} from '../../ui';

type ImpactScaleProps = {
  impact: 'low' | 'medium' | 'high';
};

const ImpactScale:
React.FC<ImpactScaleProps> = ({
  impact = 'low',
}) => {
  const pickColor = (name: string) => (name === impact ? colors.red : colors.blackInBlack);

  const config = {
    low: {
      paddingLeft: '0%',
      maxWidth: '33%',
    },
    medium: {
      paddingLeft: '33%',
      maxWidth: '50%',
    },
    high: {
      paddingLeft: '67%',
      maxWidth: '100%',
    },
  };

  return (
    <Stack
      space={4}
    >
      <Box
        color={colors.lightGrey}
        padding={0}
        borderRadius={8}
        minHeight={8}
        maxHeight={8}
      >
        <Box
          padding={0}
          paddingLeft={config[impact].paddingLeft as Percentage}
        >
          <Box
            color={colors.red}
            padding={0}
            borderRadius={8}
            minHeight={8}
            maxHeight={8}
            maxWidth={config[impact].maxWidth}
            minWidth="33%"
          />
        </Box>
      </Box>
      <Inline>
        <Box
          minWidth="33%"
          maxWidth="33%"
        >
          <BodyText
            weight="thin"
            textAlign="center"
            color={pickColor('low')}
          >
            LOW
          </BodyText>
        </Box>
        <Box
          minWidth="33%"
          maxWidth="33%"
        >
          <BodyText
            weight="thin"
            textAlign="center"
            color={pickColor('medium')}
          >
            MEDIUM
          </BodyText>
        </Box>
        <Box
          minWidth="33%"
          maxWidth="33%"
        >
          <BodyText
            weight="thin"
            textAlign="center"
            color={pickColor('high')}
          >
            HIGH
          </BodyText>
        </Box>
      </Inline>
    </Stack>
  );
};

export default ImpactScale;
